import { createStore, applyMiddleware } from 'redux';
import { persistStore } from 'redux-persist'
import thunk from 'redux-thunk';
import { rootReducer } from './reducers/rootReducer'

const store = createStore(
    rootReducer,
    applyMiddleware(thunk)
)

let persistor = persistStore(store)

export { persistor }
export default store
